export const messages = {
    'integrations.menu.item': 'Integrations',

    'integrations.modal.title': 'Integrations',
    'integrations.modal.subtitle': 'Connect WEAVR to the learning platforms used by your organization.',

    'integrations.tabs.externalLms': 'External LMS',
    'integrations.tabs.lti': 'LTI 1.3',

    'integrations.externalLms.description': 'Export procedures to an external LMS as URL activities. Pick the procedures you want to export and the version to export for each of them.',

    'integrations.deployment.label': 'Deployment',
    'integrations.deployment.placeholder': 'Select a deployment',
    'integrations.deployment.empty': 'No deployment available',

    'integrations.settings.title': 'Export settings',
    'integrations.settings.split': 'Split',
    'integrations.settings.createWbtCourse': 'Create WBT course',
    'integrations.settings.playerTemplate': 'Player template',
    'integrations.settings.contentFolder': 'Content folder',
    'integrations.settings.contentProvider': 'Content provider',
    'integrations.settings.contentServer': 'Content server',
    'integrations.settings.owner': 'Owner',

    'integrations.search.placeholder': 'Search procedures',

    'integrations.list.empty': 'There are no procedures in this company yet.',
    'integrations.list.noResults': 'No procedure matches your search.',
    'integrations.list.selectAll': 'Select all',
    'integrations.list.clearSelection': 'Clear selection',
    'integrations.list.noVersions': 'No versions uploaded',

    'integrations.version.label': 'Version',
    'integrations.version.latest': 'Latest',

    'integrations.selection.suffix': 'selected',

    'integrations.export.button': 'Export',
    'integrations.cancel.button': 'Cancel',
    'integrations.close.button': 'Close',

    'integrations.toast.success': 'The export file has been downloaded.',
    'integrations.toast.error': 'Something went wrong while exporting the selected procedures.',

    'integrations.lti.description': 'Register WEAVR as an LTI 1.3 tool in your LMS. WEAVR supports LTI Advantage dynamic registration: paste the URL below in your LMS and it will exchange the configuration with WEAVR automatically.',
    'integrations.lti.url.label': 'Dynamic registration URL',
    'integrations.lti.url.company': 'Platforms registered with this URL are linked to the company',
    'integrations.lti.url.unavailable': 'The registration URL is not available because your account is not linked to a company.',
    'integrations.lti.copy': 'Copy URL',
    'integrations.lti.copy.success': 'Registration URL copied to the clipboard.',
    'integrations.lti.copy.error': 'Could not copy the URL. Select it and copy it manually.',
    'integrations.lti.steps.title': 'How to register',
    'integrations.lti.steps.1': 'In your LMS, add a new LTI Advantage tool using dynamic registration (Moodle: "Manage tools" › "Tool URL"; Canvas: "Developer Keys" › "LTI Registration"; Brightspace: "Register Tool" › "Dynamic").',
    'integrations.lti.steps.2': 'Paste the registration URL and start the registration.',
    'integrations.lti.steps.3': 'Review and confirm the tool in the LMS. Depending on the LMS, an administrator may need to activate it before teachers can use it.',
}
